import { Action } from 'redux';
import { FUTURE } from 'src/modules/common/types/Future';
import { EVALUATION_PROPOSAL_GENERATE } from 'src/modules/evaluation/actions/EvaluationActions';
import { EvaluationState } from 'src/modules/evaluation/types/EvaluationState';

export function evaluationGenerateProposalReducer(state: EvaluationState, action: Action): EvaluationState {
  if (EVALUATION_PROPOSAL_GENERATE.isPending(action)) {
    return {
      ...state,
      generatedProposal: FUTURE.pending(),
    };
  }
  if (EVALUATION_PROPOSAL_GENERATE.isSuccess(action)) {
    return {
      ...state,
      generatedProposal: FUTURE.success(action.data),
    };
  }
  if (EVALUATION_PROPOSAL_GENERATE.isFailure(action)) {
    return {
      ...state,
      generatedProposal: FUTURE.failure(action.data),
    };
  }

  return state;
}
